import React from 'react';
import HMap from '../../features/heatMap/HMap';
import { makeStyles } from '@material-ui/core';
import { Loader } from '../../components/1elements';
import HMapSearch from '../../features/heatMap/searchBar/HMapSearch';
import HMapLeftPanel from '../../features/heatMap/leftPanel/HMapLeftPanel';
import { HMapContextProvider } from '../../features/heatMap/context/HMapContext';
import HMapActiveList from '../../features/heatMap/hmapActiveList/HMapActiveList';
import { useGMapLoad } from '../../sharedcomponents/5templates/googleMap/useGMapLoad';
import HMapSettingButton from '../../features/heatMap/components/HMapSettingsButton';
import HMapDataZoneButton from '../../features/heatMap/components/HMapDataZoneButton';
import HMapDataZoneList from '../../features/heatMap/hmapDatazoneList/HMapDatazoneList';

const HeatMap = () => {
  const classes = useStyles();
  const [leftPanelOpen, setLeftPanelOpen] = React.useState(true);
  // Load Map
  const { loadMap } = useGMapLoad();

  return (
    <HMapContextProvider>
      <div className={classes.root}>
        {/* Map Search fields */}
        <HMapSearch />

        {/* Load Google Maps */}
        {!loadMap ? <Loader /> : <HMap leftPanelOpen={leftPanelOpen} />}

        {/*
          To be addressed later:
            if first time on heatmaps => Display the create new heatmap
            else => display heatmap list
        */}
        <HMapLeftPanel open={leftPanelOpen} setOpen={setLeftPanelOpen} />

        {/* Settings Button */}
        <HMapSettingButton className={classes.mapSettingButton} />

        {/* Datazone Button */}
        <HMapDataZoneButton className={classes.mapDataZoneButton} />

        {/* Data Zones */}
        <HMapDataZoneList />

        {/* Active Heatmap List */}
        <HMapActiveList />
      </div>
    </HMapContextProvider>
  );
};

// export default HeatMap
export default React.memo(HeatMap);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    position: 'relative',
    height: '99vh',
    marginLeft: 60
  },
  mapSettingButton: {
    position: 'fixed',
    zIndex: 10,
    right: '60px',
    bottom: '23px'
  },
  mapDataZoneButton: {
    position: 'fixed',
    zIndex: 10,
    right: '60px',
    bottom: '83px'
  }
}));
